import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import { v4 as uuid } from 'uuid';
import { FlowNode, flowNodeColor, FlowType, NodeTypeComponent, } from 'fable/flowEditor';
import ActionModal from '../../containers/modals/filters';
import { SystemVariableType, } from '../../helpers/flowVariableHelpers';
import { formatPortsHelper } from '../../helpers/nodePortFormatter';
import { ConditionOutcome, FlowNodeTypes, } from '../types';
const portTranslator = (node) => [
    {
        id: uuid(),
        type: 'out',
        label: ConditionOutcome.NO_MATCH,
        connection: node.payload.non_match_node_id || uuid(),
    },
    {
        id: uuid(),
        type: 'out',
        label: ConditionOutcome.MATCH,
        connection: node.payload.match_node_id || uuid(),
    },
];
const createFiltersNode = (flowType = FlowType.FLOW_TYPE_CALL) => {
    var _a;
    return _a = class FiltersNode extends NodeTypeComponent() {
            constructor(props) {
                super(props);
                /** We have to bind this way. @boundMethod doesn't work */
                this.triggerEdit = this.triggerEdit.bind(this);
            }
            triggerEdit() {
                const { onEdit, node } = this.props;
                onEdit(node, node.nodeType);
            }
            render() {
                const { node } = this.props;
                const { rules, description = '' } = node.payload;
                const hasDescription = !!description;
                return (_jsx(FlowNode, { color: flowNodeColor.purple, icon: FiltersNode.icon, label: FiltersNode.label, text: _jsxs("div", Object.assign({ style: { height: '32px' } }, { children: [_jsx(Text.Paragraph, Object.assign({ clamp: 1, variant: "3", as: "strong" }, { children: hasDescription ? description : 'Add a description' })), _jsxs(Text.Paragraph, Object.assign({ variant: "3", as: "strong" }, { children: [rules.length, " ", rules.length === 1 ? 'rule' : 'rules'] }))] })), onEdit: this.triggerEdit }));
            }
        },
        _a.icon = 'branch',
        _a.label = 'Filters',
        _a.helpText = 'Sort conversations based on whether they match your chosen criteria.',
        _a.color = flowNodeColor.purple,
        _a.height = FlowNode.dimensions.h + 16,
        _a.translatePayload = formatPortsHelper(portTranslator),
        _a.ActionModal = ActionModal(flowType),
        _a.actionTrigger = { type: FlowNodeTypes.FILTERS },
        _a.translateScopeVariables = (node) => {
            const { payload: { rules } = {} } = node;
            const needs = [];
            if (Array.isArray(rules)) {
                rules.forEach((rule) => {
                    var _a, _b;
                    if (((_a = rule.variable) === null || _a === void 0 ? void 0 : _a.type) !== SystemVariableType.System &&
                        rule.variable.id) {
                        needs.push(rule.variable.id);
                    }
                    const isMatchScopeVariable = ((_b = rule.match) === null || _b === void 0 ? void 0 : _b.type) === SystemVariableType.Scope;
                    if (rule.match.id && isMatchScopeVariable) {
                        needs.push(rule.match.id);
                    }
                });
            }
            return {
                needs: [...new Set(needs)],
                grants: [],
            };
        },
        _a.updateConnection = (node, port, newConnection) => {
            const payload = Object.assign({}, node.payload);
            payload[port.label === ConditionOutcome.MATCH
                ? 'match_node_id'
                : 'non_match_node_id'] = newConnection;
            return Object.assign(Object.assign({}, node), { payload });
        },
        _a;
};
export const FiltersNodeEmail = createFiltersNode(FlowType.FLOW_TYPE_EMAIL);
export const FiltersNodePhone = createFiltersNode(FlowType.FLOW_TYPE_CALL);
export const FiltersNodeMessenger = createFiltersNode(FlowType.FLOW_TYPE_MESSENGER);
